import React from 'react';

import { browserHistory } from '../../constants';

import RedirectingToNewPath from './RedirectingToNewPath';

function RedirectorToNewPath({ isExternalPath = false, newPath = null }) {
  React.useEffect(() => {
    if (isExternalPath) {
      window.location.href = newPath;
    } else {
      browserHistory.replacePatched(newPath);
    }
  }, [isExternalPath, newPath]);

  return <RedirectingToNewPath newPath={newPath} />;
}

// eslint-disable-next-line import/no-default-export
export default RedirectorToNewPath;
